import api from '../../api';

// Create Stripe instance at runtime to allow outer packages
// to configure it at runtime.
// Buildtime configuration does not allow 1 Docker image
// to support multiple environments.
let stripe;
function getStripe() {
  if (!stripe) {
    stripe = Stripe(window.env.MYCOREMS_BILLING.STRIPE_KEY);
  }
  return stripe;
}

let elements;
function getElements() {
  if (!elements) {
    elements = getStripe().elements();
  }
  return elements;
}

const style = {
  base: {
    fontFamily: '"Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: '14px',
    '::placeholder': {
      fontSize: '16px',
    },
  },
};

export function createElement(type, placeholder) {
  return getElements().create(type, { style, placeholder });
}

function createClientSecret() {
  return api
    .post('payment-intents/setup')
    .then(response => response.data.clientSecret);
}

function handleCardSetupResult(result) {
  if (result.error) {
    return Promise.reject(result.error);
  }
  return result.setupIntent.payment_method;
}

function confirmCardSetup(clientSecret, nameOnCard, cardNoElement) {
  return getStripe()
    .confirmCardSetup(
      clientSecret,
      {
        payment_method: {
          card: cardNoElement,
          billing_details: {
            name: nameOnCard,
          },
        },
      },
    )
    .then(handleCardSetupResult);
}

export function createPaymentMethod(nameOnCard, cardNoElement) {
  return createClientSecret()
    .then(clientSecret => confirmCardSetup(clientSecret, nameOnCard, cardNoElement));
}
